import { parse } from 'tldts';
export var parseDomain = function (url) {
    var parsedDomain = parse(url);
    return parsedDomain;
};
